import {
  GetFantasyLeagueRequest,
  GetFantasyLeagueResponse,
  GetFantasyProjectionsRequest,
  GetFantasyProjectionsResponse,
  IngestFantasyDataRequest,
  IngestFantasyDataResponse,
} from "../models/functions";
import { makeFunctionsCall } from "./SplendorApi";

export const getFantasyProjections = makeFunctionsCall<
  GetFantasyProjectionsRequest,
  GetFantasyProjectionsResponse
>("getFantasyProjections");

export const getFantasyLeague = makeFunctionsCall<
  GetFantasyLeagueRequest,
  GetFantasyLeagueResponse
>("getFantasyLeague");

export const ingestFantasyData = makeFunctionsCall<
  IngestFantasyDataRequest,
  IngestFantasyDataResponse
>("ingestFantasyData", { timeout: 540000 });
